var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3009.5,896.1c-271.1-271.4-631.7-421-1015.8-421.1c-791.5,0-1435.7,644.2-1436,1435.9 c-0.1,253.1,66,500.1,191.7,717.9L545.6,3373l761.3-199.7c209.7,114.4,445.9,174.7,686.2,174.8h0.6c0,0,0,0,0,0 c791.4,0,1435.7-644.2,1436-1436C3429.9,1528.4,3280.7,1167.6,3009.5,896.1z M1993.7,3105.6h-0.5c-214.2-0.1-424.2-57.6-607.5-166.4 l-43.6-25.9l-451.7,118.5l120.6-440.4l-28.4-45.2c-119.5-190-182.6-409.7-182.5-635.2c0.3-658.1,535.7-1193.5,1194.1-1193.5 c318.8,0.1,618.5,124.4,843.8,350c225.3,225.6,349.4,525.5,349.3,844.4C3187,2570.1,2651.6,3105.6,1993.7,3105.6z M2648.4,2211.6 c-35.9-18-212.3-104.8-245.2-116.7c-32.9-12-56.8-18-80.7,18c-23.9,35.9-92.7,116.7-113.6,140.7c-20.9,23.9-41.9,26.9-77.7,9 c-35.9-18-151.5-55.8-288.6-178.1c-106.7-95.1-178.7-212.6-199.6-248.6c-20.9-35.9-2.2-55.3,15.7-73.2 c16.1-16.1,35.9-41.9,53.8-62.9c17.9-20.9,23.9-35.9,35.9-59.9c12-24,6-44.9-3-62.9c-9-18-80.7-194.6-110.6-266.4 c-29.1-70-58.7-60.5-80.7-61.6c-20.9-1-44.9-1.3-68.8-1.3c-23.9,0-62.8,9-95.7,44.9c-32.9,35.9-125.6,122.7-125.6,299.3 c0,176.6,128.6,347.2,146.5,371.2c17.9,24,253,386.4,613,541.8c85.6,37,152.4,59.1,204.6,75.6c86,27.3,164.2,23.5,226,14.2 c68.9-10.3,212.3-86.8,242.2-170.6c29.9-83.8,29.9-155.7,20.9-170.6C2708.2,2238.6,2684.3,2229.6,2648.4,2211.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9b94cabad2c88a37cdce40744910b70d.svg";
export { ForwardRef as ReactComponent };